import { projectApi } from "@/api/projectApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Button, Card, CardContent, CardHeader, Container, Divider, Stack, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Form, FormikProvider, useFormik } from "formik";
import { parseInt } from "lodash";
import { useSnackbar } from "notistack";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import FlagshipProjectForm from "./FlagshipProjectForm";

const WORKSPACE_PROJECT_LIST_URL = "/workspace/projects";

const initialValues = {
    owner: null,
    project_name: "",
    project_name_en: "",
    size: "",
    duration: "",
    is_flagship: true,
};

const validationSchema = yup.object().shape({
    owner: yup.object().required(),
    project_name: yup.string().required(),
    project_name_en: yup.string(),
    size: yup.string().required(),
    duration: yup.string().required(),
    is_flagship: yup.boolean(),
});

export default function ProjectCreateNewFlagship() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [createProject, createProjectResult] = projectApi.endpoints.createProject.useMutation();

    const handleCancel = () => navigate(-1);
    const handleSubmit = async (values, formikBag) => {
        // format data
        const createProjectRequestBody = {
            owner_group_id: values.owner?.id,
            project_name: values.project_name,
            project_name_en: values.project_name_en,
            size_id: parseInt(values.size),
            duration_id: parseInt(values.duration),
            is_flagship: values.is_flagship,
        };

        // call mutation
        const snackbarAction = (snackbarId) => <Button onClick={() => closeSnackbar(snackbarId)}>Close</Button>;

        try {
            const result = await createProject(createProjectRequestBody).unwrap();
            if (result.isError) {
                throw new Error(result.error ?? "cannot create project.");
            }
            enqueueSnackbar("new flagship project was created.", {
                action: snackbarAction,
            });
            navigate(WORKSPACE_PROJECT_LIST_URL);
        } catch (error) {
            enqueueSnackbar(error.message ?? error, { action: snackbarAction });
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
    });

    return (
        <>
            <Container>
                <Breadcrumbs
                    items={[
                        { label: "Projects", to: WORKSPACE_PROJECT_LIST_URL },
                        { label: "New" },
                        { label: "Create Flagship Project" },
                    ]}
                />
            </Container>
            <Container>
                <Typography variant="h1" gutterBottom sx={{ fontWeight: "bold", fontSize: 34 }}>
                    Create New Project
                </Typography>
            </Container>
            <Container sx={{ marginY: 3 }}>
                <Card variant="outlined">
                    <CardHeader title="ข้อมูลทั่วไป"></CardHeader>
                    <Divider variant="middle" />
                    <CardContent>
                        <FormikProvider value={formik}>
                            <Form>
                                <FlagshipProjectForm />
                                <Stack direction="row" spacing={1} sx={{ marginTop: 3 }}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={formik.isSubmitting || !formik.dirty}
                                        startIcon={formik.isSubmitting ? <CircularProgress size="1em" /> : <></>}
                                    >
                                        บันทึก
                                    </Button>
                                    <Button onClick={handleCancel}>ยกเลิก</Button>
                                </Stack>
                            </Form>
                        </FormikProvider>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
